import React, { forwardRef } from "react";
import { Textarea } from "@activecollab/components";
import PropTypes from "prop-types";
import CircleProgress from "../CircleProgress.jsx";
import "./TextareaProgress.less";

const TextareaProgress = forwardRef(
  (
    {
      value,
      onChange,
      onFocus,
      className,
      textareaClassName,
      maxNumChars,
      warningPercentage,
      maxReachedClass,
      warningClass,
      progressClassName,
      disabled,
      placeholder,
      autoFocus,
      textareaName,
      width,
      height,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={`textarea_progress_wrapper ${className}`}
        style={{ width: `${width}px` }}
      >
        <Textarea
          className={`textarea ${textareaClassName}`}
          maxLength={maxNumChars}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          onFocus={onFocus}
          disabled={disabled}
          ref={ref}
          placeholder={placeholder}
          name={textareaName}
          style={{ width: `${width}px`, height: `${height}px` }}
          {...props}
        />
        {value.length > 0 && (
          <CircleProgress
            className={`progress ${progressClassName}`}
            max={maxNumChars}
            numOfChars={value.length}
            maxReachedClass={maxReachedClass}
            warningClass={warningClass}
            warningPercentage={warningPercentage}
          />
        )}
      </div>
    );
  }
);

TextareaProgress.propTypes = {
  value: PropTypes.string,
  textareaName: PropTypes.string,
  progressClassName: PropTypes.string,
  maxNumChars: PropTypes.number,
  warningPercentage: PropTypes.number,
  maxReachedClass: PropTypes.string,
  warningClass: PropTypes.string,
  textareaClassName: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

TextareaProgress.defaultProps = {
  value: "",
  maxNumChars: 100,
  warningPercentage: 80,
  maxReachedClass: "circle-progress--error",
  warningClass: "circle-progress--warning",
  onChange: () => null,
  onFocus: () => null,
  autoFocus: false,
  disabled: false,
  placeholder: "",
  width: 420,
  height: 90,
  textareaClassName: "",
  progressClassName: "",
  className: "",
};

TextareaProgress.displayName = "TextareaProgress";

export default TextareaProgress;
